export default class ActivityItemTypeService {
    static get NoteId() {
        return 1;
    }
    static get PersonAlertId() {
        return 2;
    }
    static get TranscriptCourseId() {
        return 3;
    }
    static get MeetingId() {
        return 4;
    }
    static get SurveyId() {
        return 5;
    }
    static get PersonAchievementId() {
        return 6;
    }
    static get TaskId() {
        return 7;
    }
    static get PersonId() {
        return 8;
    }
    static get ResourceShareId() {
        return 9;
    }
    static get ActionPlanId() {
        return 10;
    }
    static get AcademicPlanId() {
        return 11;
    }
    static get TranscriptCourseAttendance() {
        return 12;
    }
    static get LmsAssignmentSubmission() {
        return 13;
    }
    static get Message() {
        return 14;
    }
    static get MessageThreadId() {
        return 15;
    }
    // @deprecated - Do not use it
    static get ExternalEmailMessageId() {
        return 16;
    }
    // @deprecated - Do not use it
    static get ExternalMessageThreadId() {
        return 17;
    }
    static get OpportunityId() {
        return 20;
    }
    static get FormSubmissionId() {
        return 21;
    }
    static getIcon(id) {
        switch (id) {
            case ActivityItemTypeService.NoteId:
                return "sticky-note";
            case ActivityItemTypeService.PersonAlertId:
                return "bell";
            case ActivityItemTypeService.TranscriptCourseId:
                return "users-class";
            case ActivityItemTypeService.MeetingId:
                return "calendar";
            case ActivityItemTypeService.SurveyId:
                return "paper-plane";
            case ActivityItemTypeService.PersonAchievementId:
                return "trophy";
            case ActivityItemTypeService.TaskId:
                return "tasks";
            case ActivityItemTypeService.PersonId:
                return "user-circle";
            case ActivityItemTypeService.ResourceShareId:
                return "share-alt";
            case ActivityItemTypeService.AcademicPlanId:
                return "user-chart";
            case ActivityItemTypeService.TranscriptCourseAttendance:
                return "clipboard-user";
            case ActivityItemTypeService.LmsAssignmentSubmission:
                return "copy";
            case ActivityItemTypeService.Message:
                return "envelope";
            case ActivityItemTypeService.OpportunityId:
                return "columns";
            case ActivityItemTypeService.FormSubmissionId:
                return "tasks";
            default:
                return "";
        }
    }
    static getColor(id) {
        switch (id) {
            case ActivityItemTypeService.NoteId:
                return "primary";
            case ActivityItemTypeService.PersonAlertId:
                return "danger";
            case ActivityItemTypeService.TranscriptCourseId:
                return "dark";
            case ActivityItemTypeService.MeetingId:
                return "warning";
            case ActivityItemTypeService.SurveyId:
                return "info";
            case ActivityItemTypeService.PersonAchievementId:
                return "success";
            case ActivityItemTypeService.TaskId:
                return "dark";
            case ActivityItemTypeService.PersonId:
                return "dark";
            case ActivityItemTypeService.ResourceShareId:
                return "info";
            case ActivityItemTypeService.AcademicPlanId:
                return "success";
            case ActivityItemTypeService.TranscriptCourseAttendance:
                return "primary";
            case ActivityItemTypeService.LmsAssignmentSubmission:
                return "primary";
            case ActivityItemTypeService.Message:
                return "primary";
            case ActivityItemTypeService.OpportunityId:
                return "dark";
            case ActivityItemTypeService.FormSubmissionId:
                return "dark";
            default:
                return "";
        }
    }
}
